const DropCapTextBlock = {
  getSettings: componentSettings => ({
    ...componentSettings,
    modifier: 'drop-cap'
  })
};

export default DropCapTextBlock;
